export const testimonials = [
  {
    id: 1,
    name: '摄影师 李明',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20portrait%20headshot%2C%20Asian%20man%20in%20black%20shirt%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20professional%20corporate%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    role: '自由摄影师',
    content: 'mm131 是我每天必看的灵感来源。平台的图片质量非常高，分类也很清晰，每次都能在这里找到我需要的拍摄创意和构图参考。',
    rating: 5,
  },
  {
    id: 2,
    name: '设计师 王芳',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20portrait%20headshot%2C%20Asian%20woman%20with%20glasses%2C%20creative%20designer%20look%2C%20clean%20studio%20background%2C%20warm%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
    role: '视觉设计师',
    content: '作为设计师，高质量素材库是必需品。mm131 的图库资源丰富且更新及时，为我的设计项目提供了大量优质参考，强烈推荐！',
    rating: 5,
  },
  {
    id: 3,
    name: '模特 小雅',
    avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20Asian%20woman%20portrait%20headshot%2C%20natural%20makeup%2C%20warm%20smile%2C%20soft%20studio%20lighting%2C%20clean%20background%2C%20professional%20model%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    role: '签约模特',
    content: '加入 mm131 是我模特生涯的转折点。平台给了我展示自己的舞台，专业的团队和良好的工作氛围让我快速成长。',
    rating: 5,
  },
];